module.exports = __webpack_public_path__ + "img/Group_42442@2x.5e1d6d97.png";